
import React,{ useState, useEffect, useContext } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import {Tooltip, IconButton} from '@material-ui/core';
import {useParams} from 'react-router-dom';
import { db, projectStorage } from '../firebase/firebaseConfig';
import firebase from 'firebase';
import { AuthContext } from '../context/AuthContext';
import '../styles/Modal.css';

const Modal = ({image, setImage}) => {

    const [imageArray, setImageArray] = useState([]);
    const [updatedArray, setUpdatedArray] = useState([]);
    const { currentUser } = useContext(AuthContext);
    const {albumId} = useParams();
    const collectionRef = db.collection(currentUser.email).doc(currentUser.uid).collection("albums");

    //console.log(image);
    const onClickHandler = (e) => {
        if(e.target.classList.contains("backdrop")){
            console.log(e.target.classList.contains("backdrop"));
            setImage(null);
        }
    }

    
    useEffect(()=>{
        if(imageArray.length>0){
            //console.log("in-useEffect");
            //console.log(imageArray);
            const newImageArray = imageArray.filter(doc=>(doc.index!==image.index)); 
            const unsub = collectionRef.doc(albumId).get()
            .then((doc)=>{
                let imageObj = doc.data();
               collectionRef.doc(albumId).update({
                    ...imageObj,
                    images:newImageArray,
                })
            })
            setImage(null);
            projectStorage.refFromURL(image.url).delete(); 
            
            return unsub;

        }
    },[imageArray])

    const deleteIconHandler = () =>{
        const unsub = collectionRef
        .doc(albumId)
        .onSnapshot((snapshot) => {
            if(snapshot.data()){
                console.log(snapshot.data().images);
                setImageArray(snapshot.data().images);
            }
        
        })

        return ()=> unsub();


        console.log(imageArray); 
    }

    return ( 
        <div className="backdrop" onClick={onClickHandler}>
            <div className="display__items">
                <div className="display__items__utilities" onClick={deleteIconHandler}>
                   <IconButton>
                        <DeleteIcon />
                   </IconButton>
                </div>
                <img src={image.url} alt={image.name}/>
            </div>
            
        </div>
     );
}
 
export default Modal;